/* tslint:disable:no-console */
import './vendor';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (location.hash.length > 0) {
  history.pushState({}, '', location.hash.substring(1));
}

if (environment.production) {
  enableProdMode();
}

// TODO remove or modify after https://groupby.atlassian.net/browse/EN-1863 is addressed in search
(open => {
  XMLHttpRequest.prototype.open = function() {
    arguments[1] = arguments[1].replace(/search$/, 'search?debug=true');
    const method = arguments[1];
    console.log(method);
    // tslint:disable-next-line:no-invalid-this
    return open.apply(this, arguments);
  };
})(XMLHttpRequest.prototype.open);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts